import { Modal as MUIModal, type Breakpoint, type ModalProps as MUIModalProps, type SxProps } from "@mui/material";
import React from "react";

import {
	ModalHeaderContainer,
	ModalContainer,
	ModalContentContainer,
	ModalTitleContainer,
	ModalCloseButton,
	ModalSubTitleContainer,
} from "../components";

interface ModalSlotProps {
	contentContainer?: {
		sx: SxProps;
	};
}

export interface ModalProps extends Omit<MUIModalProps, "children" | "maxWidth" | "title"> {
	readonly children: React.ReactNode;
	readonly title: React.ReactNode | string;
	readonly subTitle?: React.ReactNode | string;
	readonly size?: Breakpoint;
	readonly slotProps?: MUIModalProps["slotProps"] & ModalSlotProps;
	onClose(e: React.UIEvent | object | undefined, reason?: "backdropClick" | "escapeKeyDown"): void;
}

export const Modal: React.FC<ModalProps> = ({ title, subTitle, children, size, sx, slotProps, ...props }) => {
	const { contentContainer, ...modalSlotProps } = slotProps || {};

	return (
		<MUIModal slotProps={modalSlotProps} {...props}>
			<ModalContainer disableGutters maxWidth={size} sx={sx}>
				<ModalHeaderContainer divider>
					<ModalTitleContainer>{title}</ModalTitleContainer>
					<ModalSubTitleContainer>{subTitle}</ModalSubTitleContainer>
					<ModalCloseButton onClick={props.onClose} />
				</ModalHeaderContainer>
				<ModalContentContainer sx={contentContainer?.sx}>{children}</ModalContentContainer>
			</ModalContainer>
		</MUIModal>
	);
};
